import "./Competition.css";
import { NavLink, useParams } from "react-router-dom";
import { useState, useMemo, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import Skeleton from "../../components/Skeleton";
import worldCup from "../../pages/home/HomeImage/worldcup.png";

const Competition = ({ dark, MyBaseUrl }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [competitions, setCompetitions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [activeTab, setActiveTab] = useState("All");

  const createSlug = (name) => {
    return name
      ?.toLowerCase()
      .trim()
      .replace(/\s+/g, "-")
      .replace(/[^a-z0-9-]/g, "");
  };

  useEffect(() => {
    const fetchCompetitions = async () => {
      try {
        setLoading(true);
        setError(null);

        const res = await fetch(`${MyBaseUrl}/competitions`);

        if (!res.ok) {
          throw new Error("Failed to fetch competitions");
        }

        const data = await res.json();

        // adjust if your API shape is different
        setCompetitions(data?.data || data || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (MyBaseUrl) {
      fetchCompetitions();
    }
  }, [MyBaseUrl]);

  const safeCompetitions = Array.isArray(competitions) ? competitions : [];

  const filteredCompetitions = useMemo(() => {
    let filtered = [...safeCompetitions];

    if (activeTab === "League") {
      filtered = filtered.filter((item) => item?.league?.type === "League");
    }

    if (activeTab === "Cup") {
      filtered = filtered.filter((item) => item?.league?.type === "Cup");
    }

    if (activeTab === "Country") {
      filtered = filtered.sort((a, b) =>
        (a?.country?.name || "").localeCompare(b?.country?.name || ""),
      );
    }

    if (searchTerm) {
      filtered = filtered.filter((item) =>
        item?.league?.name?.toLowerCase().includes(searchTerm.toLowerCase()),
      );
    }

    return filtered;
  }, [safeCompetitions, activeTab, searchTerm]);

  return (
    <div className="competition-page">
      <Helmet>
        <title>Football Competitions | Leagues & Cups</title>
      </Helmet>

      <div className="competitionWrapper">
        <h1
          className="title"
          style={dark ? { color: "#fafafaff" } : { color: "#161819" }}>
          Competitions
        </h1>

        <section className="tabs">
          <ul>
            {["All", "League", "Cup", "Country"].map((tab) => (
              <li
                key={tab}
                onClick={() => setActiveTab(tab)}
                style={
                  activeTab === tab
                    ? {
                        backgroundColor: dark ? "#1f1f1fff" : "#e6e6e6",
                        color: dark ? "#fff" : "#3e3f3f",
                        cursor: "pointer",
                      }
                    : {
                        color: dark ? "#c9c9c9ff" : "#5f5f5fff",
                        cursor: "pointer",
                      }
                }>
                {tab}
              </li>
            ))}
          </ul>
        </section>

        {/* SEARCH */}
        <div className="searchContainer">
          <input
            type="text"
            placeholder="Search league..."
            value={searchTerm || ""}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={
              dark
                ? {
                    backgroundColor: "#222",
                    color: "#fff",
                    border: "none",
                  }
                : {}
            }
          />
        </div>

        {/* LIST */}
        <section className="firstsection">
          {loading && <Skeleton dark={dark} />}

          {error && <p style={{ color: "red" }}>{error}</p>}

          {!loading && !error && filteredCompetitions.length === 0 && (
            <p>No competitions found.</p>
          )}

          {!loading &&
            !error &&
            filteredCompetitions.length > 0 &&
            filteredCompetitions.map((item, index) => {
              const league = item?.league;
              if (!league?.id) return null;

              const slug = createSlug(league.name);

              return (
                <NavLink
                  key={league.id || index}
                  to={`/competition/${slug}/${league.id}`}
                  style={{
                    textDecoration: "none",
                    color: "inherit",
                  }}>
                  <div className="competitionCard">
                    <img
                      src={league?.id === 1 ? worldCup : league?.logo}
                      alt={league?.name}
                      onError={(e) => {
                        e.target.src =
                          "https://via.placeholder.com/80?text=No+Logo";
                      }}
                    />

                    <nav
                      style={
                        dark
                          ? { backgroundColor: "#414141ff" }
                          : { backgroundColor: "#eef6f8" }
                      }>
                      {" "}
                      <h2
                        style={
                          dark ? { color: "#fff" } : { color: "#575757dc" }
                        }>
                        {" "}
                        {league?.name || "Unknown League"}
                      </h2>{" "}
                    </nav>
                  </div>
                </NavLink>
              );
            })}
        </section>
      </div>
    </div>
  );
};

export default Competition;
